// import React, { useState } from "react";
// import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

// import { GlobalContextProvider } from "../context/GlobalContext";

// import CampaignRoutes from "./CampaignRoutes";
// import CardLayout from "../components/DealerManagement/CardsLayout/CardLayout";
// import CardRoutes from "./AdminRoutes"; // Import the new CardRoutes component
// import DealerManagement from "../components/DealerManagement";
// import LeadRoutes from "./LeadRoutes";
// import Login from "../components/DealerAdminDashboard/Login";
// import LoginLayout from "../components/Layout/LoginLayout";
// import ProductRoutes from "./ProductRoutes";
// import SalesRoutes from "./SalesRoutes";
// import LogisticsRoutes from "./Logistics";

// import "./App.css";
// import UserRoutes from "./UserRoutes";
// import DealerRoutes from "./DealerRoutes";
// import TermRoutes from "./TermRoutes";
// import PreSalesRoutes from "./PreSalesRoutes";
// import NotFound from "../pages/NotFound";
// import ServiceRoutes from "./ServiceRoutes";
// import CustomerConfigUploadForm from "../components/DealerManagement/Admin/OnBoardManagement/Onboard/CustomerConfigUploadForm";
// import { AuthProvider } from "../context/AuthContext";
// import InactivityHandler from "../components/DealerAdminDashboard/InActivity";
// import VehicleGetpassDetails from "../components/DealerManagement/Services/VehicleGetPassDetails";
// import ProtectedRoute from "./ProtectedRoute";


// const RouteComponent = () => {
//   const [isLoggedIn, setIsLoggedIn] = useState(() => {
//     return localStorage.getItem("isLoggedIn") === "true";
//   });

//   const handleLogin = () => {
//     setIsLoggedIn(true);
//     localStorage.setItem("isLoggedIn", "true");
//   };

//   const handleLogout = () => {
//     setIsLoggedIn(false);
//     localStorage.removeItem("isLoggedIn");
//   };

//   return (
//     <Router>
//       <AuthProvider>
//         {/* <InactivityHandler>     */}
//           <div>
//           <Routes>
//             <Route path="/vhichal-get-pass-Details/:id" element={<VehicleGetpassDetails/> }  />
//             <Route path="/customer-details-updatetion-form/:id" element={<CustomerConfigUploadForm/> }  />
//             <Route element={<LoginLayout />}>
//               <Route path="/" element={<Login onLogin={handleLogin} />} />
//               {isLoggedIn ?<Route path="/cards" element={<DealerManagement />} />: <Route path="*" element={<Navigate to="/" replace />} />}
              
//             </Route>
            
//             <Route element={<CardLayout />}>
        
//             {CardRoutes()}
//               {CampaignRoutes()}
//               {LeadRoutes()}
//               {ProductRoutes()}
//               {SalesRoutes()}
//               {UserRoutes()}
//               {DealerRoutes()}
//               {TermRoutes()}
//               {PreSalesRoutes()}
//               {LogisticsRoutes()}
//               {ServiceRoutes()}
           
           
//             </Route>

//             {/* Catch-all route for 404 Not Found */}
//             <Route path="*" element={<NotFound />} />
//           </Routes>
//         </div>
//         {/* </InactivityHandler> */}
//       </AuthProvider>
//     </Router>
//   );
// };

// export default RouteComponent;


import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import CampaignRoutes from "./CampaignRoutes";
import CardLayout from "../components/DealerManagement/CardsLayout/CardLayout";
import CardRoutes from "./AdminRoutes"; 
import DealerManagement from "../components/DealerManagement";
import LeadRoutes from "./LeadRoutes";
import Login from "../components/DealerAdminDashboard/Login";
import LoginLayout from "../components/Layout/LoginLayout";
import ProductRoutes from "./ProductRoutes";
import SalesRoutes from "./SalesRoutes";
import LogisticsRoutes from "./Logistics";
import UserRoutes from "./UserRoutes";
import DealerRoutes from "./DealerRoutes";
import TermRoutes from "./TermRoutes";
import PreSalesRoutes from "./PreSalesRoutes";
import NotFound from "../pages/NotFound";
import ServiceRoutes from "./ServiceRoutes";
import CustomerConfigUploadForm from "../components/DealerManagement/Admin/OnBoardManagement/Onboard/CustomerConfigUploadForm";
import { AuthProvider } from "../context/AuthContext";
import VehicleGetpassDetails from "../components/DealerManagement/Services/VehicleGetPassDetails";
import ProtectedRoute from "./ProtectedRoute";
import WarrantyRoutes from "./WarrantyRoutes";
import NotificationRoutes from "./NotificationRoutes";
import OrderManagementRoutes from "./OrderManagementRoutes";
import ForgotPassword from "../components/DealerAdminDashboard/ForgotPassword";
import ResetPassword from "../components/DealerAdminDashboard/ResetPassword";

const RouteComponent = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem("isLoggedIn") === "true";
  });
  
  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem("isLoggedIn", "true");
  };
  
  const version = "Version-1-30-12-2025"
  
  return (
    <Router>
      <AuthProvider>
        <div style={{height:"100%"}}>
          <Routes>
            <Route path="/vhichal-get-pass-Details/:id" element={<ProtectedRoute component={VehicleGetpassDetails} />} />
            <Route path="/customer-details-updatetion-form/:id" element={<CustomerConfigUploadForm />} />
            <Route path="/reset-password/:id" element={<ResetPassword/>} />
            
            <Route element={<LoginLayout />}>
              <Route path="/" element={<Login onLogin={handleLogin} />} />
              <Route path="/forgot-password"  element={ <ForgotPassword/> } />
              {/* <Route path="/reset-password" element={ <ResetPassword/> } /> */}
              <Route path="/cards" element={<ProtectedRoute component={DealerManagement} />} />
              {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
            </Route>
            
                      <Route element={<CardLayout />}>
        
                    {CardRoutes()}
                    {CampaignRoutes()}
                    {LeadRoutes()}
                     {ProductRoutes()}
                     {SalesRoutes()}
                     {UserRoutes()}
                    {DealerRoutes()}
                    {TermRoutes()}
                    {PreSalesRoutes()}
                    {LogisticsRoutes()}
                   {ServiceRoutes()}
                   {WarrantyRoutes()}
                   {NotificationRoutes()}
                   {OrderManagementRoutes()}
                    </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
};

export default RouteComponent;

